import { render, staticRenderFns } from "./box1.vue?vue&type=template&id=735f3f15&scoped=true&"
import script from "./box1.vue?vue&type=script&lang=js&"
export * from "./box1.vue?vue&type=script&lang=js&"
import style0 from "./box1.vue?vue&type=style&index=0&id=735f3f15&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735f3f15",
  null
  
)

export default component.exports